import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useCustomFetchApi from '../../utils/customFetchApi';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import './admin.scss';

export default function AdminLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { login, isAuthenticated } = useAdminAuth();
  const api = useCustomFetchApi();

  useEffect(() => {
    if (isAuthenticated && isAuthenticated()) {
      navigate('/admin', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/login', { email, password }, { skipAuth: true });
      if (res?.user && res?.token) {
        // Leverage AdminAuthContext.login which validates admin flag
        login(res.user, res.token);
        const redirectTo = (location.state && location.state.from && location.state.from.pathname) || '/admin';
        navigate(redirectTo, { replace: true });
      } else {
        setError('Invalid server response');
      }
    } catch (err) {
      setError(err.message || 'Failed to login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-auth-container">
      <div className="admin-card">
        <h2>Admin Login</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit} className="admin-form">
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required disabled={loading} />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required disabled={loading} />
          </div>
          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
